import * as React from "react";
import { Scoreboards } from "../../../../../constants";
import { eBranches } from "sb-helpers";
import { Scoreboard } from "../../Scoreboard";
import { renderMiniTeamsScore } from "./renderMiniTeamsScore";
export const renderMiniScore = (score1, score2, sportId, props) => Scoreboards[eBranches[sportId]]
    ? React.createElement(Scoreboard, Object.assign({}, props))
    : renderMiniTeamsScore(score1, score2);
//# sourceMappingURL=renderMiniScore.js.map